import React, {Fragment, useState, useEffect } from 'react';
import { Table, Row, Col, Button} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

import ReactHTMLTableToExcel from "react-html-table-to-excel";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaFileDownload} from 'react-icons/fa';

import SelectInput from "../selectInput";

import TablaInf2_Detallado from './tablaInf2_detallado'; //REsumen; Cantidad de lotes y proyectos

import TablaInf2_Madre from './tablaInf2_madre'; // Todos los campos --- hide
import TablaInf2_Seleccionados from './tablaInf2_seleccionados'; // Campos seleccionados ---> Es la visible
import TablaInf2_Analitico from './tablaInf2_analitico'; // analitico ---hide
import TablaInf2_Actuaciones from './tablaInf2_actuaciones'; // actuaciones ---hide

import Map_View_Expedientes from '../map_view_expedientes';

import {optionsRP2_Todos, optionsPrograma_Todos, optionsEstado_Todos, optionsTipo_Todos, optionsRegiones_todos, optionsResponsable_Todos } from "../../datos/options";

//CAMBIO 27jun24: importar y no declararlas en este archivo
import { columnas, columnasMadre, columnasAnalitico, columnasActuaciones } from "../../datos/columns"

const SelectInf_Detallado = ({name}) => {

	const nameLogin = name;

	const [action, setAction] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	const [datos_Inf2_finalizadosTotal, setdatos_Inf2_finalizadosTotal]= useState(null); //ADD 27-09-2022

	const [datosS, setDatos] = useState(null);// ESTADO para recibir datos de la consulta obtenerRep2_FinalizadosDetalle —-> /reporte2_Detalle
	//console.log("datosS---->", datosS)

	const [datosGEO, setDatosGEO] = useState(null);// ESTADO para construir geojson

	const [exportGEOJSON, setExportGEOJSON ] = useState(null);

	//const [datosOriginal, setDatosOriginales] = useState(null);
	const [datosMadre, setDatosMadre] = useState(null); //ESTADO para TODOS los datos
	
	const [datos_Inf2_Analitico, setdatos_Inf2_Analitico]= useState(null);
	const [datos_Inf2_Actuaciones, setdatos_Inf2_Actuaciones]= useState(null);

	const [search, setSearch] = useState(""); //posible borrar
	const [searchPartido, setSearchPartido] = useState(0);
	const [searchEstado, setSearchEstado] = useState("");
	const [searchTipo, setSearchTipo] = useState("");
	const [searchRegion, setSearchRegion] = useState("");

	const [filtro, setFiltro] = useState({ //PROBAR con 2 filtros
		prioritario:"TODOS",
		programa:"",
		partido:0,
		tipo:"",
		estado: "AFECTADO CON RESOLUCIÓN",//Poner un valor por default
		datos_05_responsable: "",
		region: ""
	});
	
	const {prioritario, programa, partido, tipo, estado, datos_05_responsable, region } = filtro;

	const [showDraw, setShowDraw] = useState(false);//cambiar luego a false para que esté apagada por default

	const handleClose = () => {		
		setShowDraw(false);		
	};

	const guardarEditRegistro = () => {
		setDatosGEO(null)
		setExportGEOJSON(null)
		setAction(null);
		setShowDraw(false);
	}

	/*var buttonClick = (e)=>{
		e.preventDefault();
		
		setShowDraw(true);			
	}*/

	//24-09-2022 - agregado: poner fecha por default
	const [startDate, setStartDate] = useState(new Date('2014-01-01'));
  	const [endDate, setEndDate] = useState(new Date('2027-12-31'));

	const [ultimoDia, setUltimoDia] = useState(new Date('2027-12-31'));

	/*REVISAR
	useEffect(()=>{
		//var x = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
		var x = new Date(startDate)
		x.setMinutes(startDate.getMinutes() + startDate.getTimezoneOffset())
		setStartDate(x);
	}, [startDate]);*/
	

	useEffect(()=>{
		//var y = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
		let y = new Date(endDate);
		y.setMinutes(y.getMinutes() + y.getTimezoneOffset())
		setUltimoDia(y);
	}, [endDate]);

	let _fechaInicio = null;
	if (startDate === null) {
		_fechaInicio = null;
	} else if (startDate !== null || startDate !== ""){
		_fechaInicio = new Date(startDate);
		_fechaInicio.setMinutes(_fechaInicio.getMinutes() + _fechaInicio.getTimezoneOffset())
	}

	const url = `/api/api_serv/reportes/reporte2_Detalle/?prioritario=${prioritario}&programa=${programa}&partido=${partido}&tipo=${tipo}&estado=${estado}&start=${startDate}&end=${ultimoDia}&region=${region}&datos_05_responsable=${datos_05_responsable}`;
	const urlRP2 = `/api/api_serv/reportes/reporte2_Total/?prioritario=${prioritario}&programa=${programa}&partido=${partido}&tipo=${tipo}&estado=${estado}&start=${startDate}&end=${ultimoDia}&region=${region}&datos_05_responsable=${datos_05_responsable}`;
	
	const url_Madre = `/api/api_serv/reportes/reporte2_Madre/?prioritario=${prioritario}&programa=${programa}&partido=${partido}&tipo=${tipo}&estado=${estado}&start=${startDate}&end=${ultimoDia}&region=${region}&datos_05_responsable=${datos_05_responsable}`;

	const urlRepo_Analitico = `/api/api_serv/reportes/reporte2_Analitico/?prioritario=${prioritario}&programa=${programa}&partido=${partido}&tipo=${tipo}&estado=${estado}&start=${startDate}&end=${ultimoDia}&region=${region}&datos_05_responsable=${datos_05_responsable}`;
	const urlRepo2_Actuaciones = `/api/api_serv/reportes/reporte2_Actuaciones/?prioritario=${prioritario}&programa=${programa}&partido=${partido}&tipo=${tipo}&estado=${estado}&start=${startDate}&end=${ultimoDia}&region=${region}&datos_05_responsable=${datos_05_responsable}`;
	//nuevo endpoint (9-jun-2025)
	const urlGet_Geo = `/api/api_serv/reportes/reporte2_Detalle_Geo/?prioritario=${prioritario}&programa=${programa}&partido=${partido}&tipo=${tipo}&estado=${estado}&start=${startDate}&end=${ultimoDia}&region=${region}&datos_05_responsable=${datos_05_responsable}`;
	
	//****  IMPORTANTE: cuando cambia filtro o rango fechas, llamar functions
	useEffect(() => {
		getDatos(url);
		getdatos_Inf2_finalizadosTotal(urlRP2);
	},[filtro, startDate, ultimoDia]); // POR AHORA UNA SOLA VEZ, //NO  ---> SOLO CUANDO CAMBIO EL estado LLAMAR NUEVAMENTE // COMENTAR filtro.estado
		
	//**consultar los datos para el reporte2
	const getDatos = async (urlM) => {

		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', jwt_token: localStorage.token }

		const res = await fetch(urlM, { headers })
		.then(res => res.json())
		.then(res => {
			setDatos(res)
			//setDatosOriginales(res)
			//setDatosGEO(res)
		})
		//.then(res => setDatosOriginales(res))
		.catch(err => console.log(err));
	}

	const getDatosMadre = async (urlM) => { // para table madre

		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', jwt_token: localStorage.token }

		const res = await fetch(urlM, { headers })
		.then(res => res.json())
		.then(res => {
			setDatosMadre(res)			
		})
		.catch(err => console.log(err));
	}

	const getdatos_Inf2_finalizadosTotal = async (urlRP2) => {

		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', jwt_token: localStorage.token };
		const res = await fetch(urlRP2,{ headers })
		.then(res => res.json())
		.then(res => setdatos_Inf2_finalizadosTotal(res))
		.catch(err => console.log(err));
	}

	//add 27-dic-2022 getdatos_Inf2_analitico
	const getdatos_Inf2_analitico = async (url) => {

		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', jwt_token: localStorage.token };

		const res = await fetch(url,{ headers })
		.then(res => res.json())
		.then(res => setdatos_Inf2_Analitico(res))
		.catch(err => console.log(err));
	}

	const getdatos_Inf2_Actuaciones = async (url) => {

		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', jwt_token: localStorage.token };

		const res = await fetch(url,{ headers })
		.then(res => res.json())
		.then(res => setdatos_Inf2_Actuaciones(res))
		.catch(err => console.log(err));
	}

	//para datos GEO (9-jun-2025)
	const getdatos_Inf2_GEO = async (url) => { //este es el fetch para geojson
		//console.log("PASOS GEO - 2")
		setIsLoading(true);

		const headers = {
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			jwt_token: localStorage.token,
			'Authorization': localStorage.tokenT, roleT: localStorage.roleT, username:localStorage.username
		};		

		try {
			const response = await fetch(url,{ headers });
			if (!response.ok) {
				throw new Error('Error al obtener los datos');
			}
			const data = await response.json();
			setDatosGEO(data);
		} catch (error) {
			console.error("Error al cargar el mapa:", error);
			setError("Error al cargar el mapa. Por favor, intente nuevamente.");
		}
		finally {
			setIsLoading(false);
		}
	}

	

	//**abre Estados y effects - Generacion de geojson descarga -05agos2023- */
	useEffect(()=>{
		if(datosGEO !== null){ //solo si NO es null

			const respuesta= datosGEO.map((element, index) => {
				
				let geomA="";
				
				if(element.geom_geojson === null || element.geom_geojson === "{\"type\":\"GeometryCollection\",\"geometries\":[]}" || element.geom_geojson === '{"type":"GeometryCollection","geometries":[]}'){
					//console.log("NO TIENE DATOS GEO");
					//return {"type":"GeometryCollection", "properties": {},"geometries":[]};
					geomA = 'sin geom'
				} else {
					//console.log("TIENE DATOS GEO");
					geomA = 'geom'
				}
				//console.log(index, element.geom_geojson)
				//console.log(index, element.geom_geojson.geometries); 

				let geom_multi = JSON.parse(element.geom_multi);// no usar geom_geojson (viene como GeometryCollection)
				//console.log(geom_multi);

				let aliasA = element.nombre_proyecto; //ALIAS
				let expedienteA = element.expediente;
				let estadoA = element.estado;
				let programaA = element.programa;
				let tipoA = element.tipo;
				let partidoA= element.partido_nombre;
				let cantLotesA = element.cantidad_lotes;				
				let cantLotesAdjA = element.cantidad_lotes_adjudicables;
				let porcLotesMunA = element.porc_lotes_municipales;
				let lotesAdqMunA = element.lotes_adquiridos_municipio;
				let id_10AN = element.sistema_agua;
				let id_11AN = element.eliminacion_excretas;
				let nomenclaSintesisA = element.datos_18_sintesis_nomenclatura;
				/*let id_12AN = element.año_emision;
				let id_13AN = element.periodo;*/
				let id_14AN = element.region ;				

				let id_1CSP;
				let id_2CSP;
				let id_3CSP;
				let id_4CSP;//agregar 6 nuevas columnas - 12jul2023
				let id_5CSP;
				let id_8CSP;
				let id_9CSP;
				let id_10CSP;
				let id_13CSP;
				let id_14CSP;
				let id_15CSP;
				let id_18CSP;

				//EX 15-09-2026: array_csp puede venir null (expediente sin CSP) y el .map de abajo rompia la pantalla
				let array = element.array_csp || [];
				array.map((item, index)=>{
					id_1CSP = item.csp_1_tamaño_medio_lotes_residenciales;
					id_2CSP = item.csp_2_actor_encargado_obras_infra;
					id_3CSP = item.csp_3_financiamiento_publico_obras_infra;
					id_4CSP = item.csp_4_jurisdiccion_infra;
					id_5CSP = item.csp_5_organismo_financiamiento_infra;
					id_8CSP = item.csp_8_financiamiento_publico_obras_viv
					id_9CSP = item.csp_9_jurisdiccion_viv;
					id_10CSP = item.csp_10_organismo_financiamiento_viv;
					id_13CSP = item.csp_13_financiamiento_publico_obras_equip;
					id_14CSP = item.csp_14_jurisdiccion_equip;
					id_15CSP = item.csp_15_organismo_financiamiento_equip;
					id_18CSP = item.csp_18_pl_mensura_estado;
				});				

				let propiedades =  {
					alias: `${aliasA}`,
					expediente: `${expedienteA}`,
					programa: `${programaA}`,
					tipo: `${tipoA}`, 
					estado: `${estadoA}`, 
					partido: `${partidoA}`,
					cant_lotes: `${cantLotesA}`,
					cant_lotes_adjudicables : `${cantLotesAdjA}`,
					porc_lotes_municipales : `${porcLotesMunA}`,
					lotes_adquiridos_municipio : `${lotesAdqMunA}`,
					sistema_de_agua : `${id_10AN}`,
					eliminación_de_excretas : `${id_11AN}`,
					datos_catastrales_dominiales_síntesis : `${nomenclaSintesisA}`,
					//año_emision : `${id_12AN}`,
					//periodo: `${id_13AN}`,
					tamaño_medio_lotes_residenciales: `${id_1CSP}`,
					actor_encargado_de_las_obras: `${id_2CSP}`,
					financ_público_obras_infra: `${id_3CSP}`,
					jurisdiccion_financ_público_obras_infra: `${id_4CSP}`,
					organismo_financ_público_obras_infra: `${id_5CSP}`,
					financ_público_obras_viviendas: `${id_8CSP}`,
					jurisdiccion_fpov: `${id_9CSP}`,
					organismo_fpov: `${id_10CSP}`,
					financ_público_obras_equip_comunitario: `${id_13CSP}`,
					jurisdiccion_fpoec: `${id_14CSP}`,
					organismo_fpoec: `${id_15CSP}`,					
					plano_estado_de_la_tramitación : `${id_18CSP}`,	
					region: `${id_14AN}`,
					geom: `${geomA}`
				};
						               
				
				let features = {
					"type": "Feature",
					"properties": propiedades,
					"geometry": geom_multi
				}
				return features;					
				        
			});
			//console.log("RESPUESTA------>", respuesta);
			
			const nuevoG = {
				"type": "FeatureCollection",
				"features": respuesta
			};

			setExportGEOJSON(nuevoG)
			
			/*if(action === 'download') {
				exportData()
			} else if(action === 'view') {
				setShowDraw(true)
			}*/

		} //cierra if datosS
	}, [datosGEO])

	useEffect(() => {
		if(exportGEOJSON !== null && action === 'download'){
			exportData()
		}
	}, [action, exportGEOJSON])

	useEffect(() => {
		if(datosGEO !== null && action === 'view'){
			setShowDraw(true)
		}
	}, [action,datosGEO])

	const exportData = () => {
		const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
			JSON.stringify(exportGEOJSON) //data
		)}`;
		const link = document.createElement("a");
		link.href = jsonString;
		link.download = "generación_de_suelo_urbano.geojson";
	
		link.click();
		setDatosGEO(null)
		setExportGEOJSON(null)
		setAction(null)
		setShowDraw(false)
	};
	//**cierra generacion de geojson */
	

	//***TODO PARA SEARCH***********
	//****************************04-05***CADA VEZ que CAMBIA arrayBusqueda

	//****************************************************************************************
	//NO BORRAR!!!
	//Se consultaban todos los datos y luego se filtraba usando expresiones regulares
	/*useEffect(()=>{
		//console.log("HACER BUSQUEDA CON MULTIPLES VARIABLES"); //sobre datos Originales

		if(datosS !== null){

			const regexExp = new RegExp(arrayBusqueda.expB, 'i');
			//console.log(regexExp);
			//const REGEX = /a|b/g;
			//const REGEX = /[0-59]/g;
			//console.log(REGEX);

			var rxPartido = /\d{1}/ ;
			//console.log(arrayBusqueda.partidoB);
			//console.log(typeof(arrayBusqueda.partidoB));

			var xF = parseInt(arrayBusqueda.partidoB);
			//console.log(typeof(xF));
			//console.log(`${xF}`);
			//console.log(xF);
			var zF = `${xF}`;

			//const regexPartido = new RegExp(arrayBusqueda.partidoB{2});
			const uno = /^d/;
			//console.log(uno);
			//const regexPartido = new RegExp(/^`${arrayBusqueda.partidoB}/);
			//const regexPartido = new RegExp(arrayBusqueda.partidoB); //  /^d/
			var regexPartido =  new RegExp(`^${arrayBusqueda.partidoB}{1,3}`); //   /^d{1,3}/ ;
			//let uno = new RegExp(`^${arrayBusqueda}{${nro}}`);


			if(xF === 0 ){
				regexPartido = /./;
			} else if(xF > 0 && xF < 10){
				//console.log("PARA Alsina");
				const arrayB1 = `${arrayBusqueda.partidoB}`;
				regexPartido = new RegExp(`^${arrayB1}{1,3}`);
			} else if(xF > 9 && xF < 99) {
				//console.log("PARA Benito Juarez");
				const arrayB2 = `${arrayBusqueda.partidoB}`;
				regexPartido =  new RegExp(`^${arrayB2}{1,3}`);
			} else {
				regexPartido = new RegExp(`^${arrayBusqueda.partidoB}{1,3}`);
			}

			//console.log(regexPartido);


			//const rxPartido = /\arrayBusqueda.partidoB{2}/;
			//const regexPartido =  /[0-9]{1,3}/ ; //     /\d{1,3};
			//const regexPartido = /\d{1,3}/g;
			//const partidoBusqueda = arrayBusqueda.partidoB

			//const regexPartido = /partidoBusqueda/;

			const regexEstado = new RegExp(arrayBusqueda.estadoB, 'i');
			//console.log(regexEstado);
			const regexAlias= new RegExp(arrayBusqueda.aliasB, 'i');
			//console.log(regexAlias);
			const regexPrograma= new RegExp(arrayBusqueda.programaB, 'i');
			//console.log(regexPrograma);
			const regexTipo= new RegExp(arrayBusqueda.tipoB, 'i');
			//console.log(regexTipo);
			const regexTitular= new RegExp(arrayBusqueda.titularB, 'i');
			//console.log(regexTitular);


			const filtradoP = datosOriginal.filter((item, index) =>{

				//VERIFICAR solo donde sean iguales para evitar que tome por ejemplo 1 para (todos los que empiezan con 1)1, 11, 120....
				if(parseInt(arrayBusqueda.partidoB) ===0){
					//console.log("PARTIDO es VALUE CERO _____  DENTRO del primer IF");
					//console.log(regexPartido.test(item.partido));
					//console.log(/./.test(item.partido));

					return regexExp.test(item.expediente) && /./.test(item.partido) && regexEstado.test(item.estado) && regexAlias.test(item.alias)  && regexPrograma.test(item.programa) && regexTipo.test(item.tipo) && regexTitular.test(item.titular_tierra)

				} else if(item.partido === parseInt(arrayBusqueda.partidoB)){

					//console.log("partido y array son iguales");
					//console.log(item.partido);
					//console.log(parseInt(arrayBusqueda.partidoB));
					//console.log(regexPartido.test(item.partido));

					//console.log(/arrayBusqueda.partidoB{2}/.test(item.partido));
					//console.log(rxPartido.test(item.partido));
					return regexExp.test(item.expediente) && regexPartido.test(item.partido) && regexEstado.test(item.estado) && regexAlias.test(item.alias)  && regexPrograma.test(item.programa) && regexTipo.test(item.tipo) && regexTitular.test(item.titular_tierra)
					//return regexExp.test(item.expediente) && /arrayBusqueda.partidoB{2}/.test(item.partido) && regexEstado.test(item.estado) && regexAlias.test(item.alias)  && regexPrograma.test(item.programa) && regexTipo.test(item.tipo) && regexTitular.test(item.titular_tierra)

				}
			})
			//console.log(filtradoP);
			setDatos(filtradoP);
			setDatosMadre(filtradoP);
			//setDatosOriginales(filtradoP)
		}

	},[arrayBusqueda]);*/
	//*****************************************************************


	//***Estado***
	const handleOnChangeEstado = (e) => {

		if(e.value){
			if(e.value !== null){
				setSearchEstado(e.value);
				//setArrayBusqueda({...arrayBusqueda,  "estadoB":e.value} );
				setFiltro({...filtro,  "estado":e.value} );
				//console.log("AAA");
			}
		} else if( e.value === ""){
			setSearchEstado(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			//setArrayBusqueda({...arrayBusqueda,  "estadoB":e.value} );
			setFiltro({...filtro,  "estado":e.target.value} )
			//console.log("BBB");

		} else if (e.target.value){
			if(e.target.value !== null){
				setSearchEstado(e.target.value);
				//setArrayBusqueda({...arrayBusqueda,  "estadoB":e.target.value} )
				setFiltro({...filtro,  "estado":e.target.value} )
				/*if(e.target.value === "AFECTADO CON RESOLUCIÓN" || e.target.value === "EN PROCESO"){
					setInputDisable(false);
				} else {
					setInputDisable(true);
				}*/
				//console.log("CCC");
			}
		} else {
			//console.log("____SELECCIONADO SIN VALOR");
			setSearchEstado(/./);
			//setArrayBusqueda({...arrayBusqueda,  "estadoB":""} )
			setFiltro({...filtro,  "estado":""} )
			//console.log("DDD");
		}
	}
	//---Estado---

	//***Partido***
	const handleOnChangePartido = (e) => {

		if(e.value){
			//console.log(e.value);

			if(e.value !== null){
				setSearchPartido(e.value);
				//setArrayBusqueda({...arrayBusqueda,  "partidoB":e.value} )
				setFiltro({...filtro,  "partido":e.value} )
			}
		} else if( e.value === ""){
			setSearchPartido(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			//setArrayBusqueda({...arrayBusqueda,  "partidoB":e.value} )
			setFiltro({...filtro,  "partido":e.value} )

		} else if (e.target.value){
			//console.log(e.target);
			if(e.target.value !== null){
				//console.log("VALUE PARTIDO");
				//console.log(e.target.value);
				if(e.target.value === 0){
					setSearchPartido(e.target.value);
					//setArrayBusqueda({...arrayBusqueda,  "partidoB":0} )
					setFiltro({...filtro,  "partido":0} )
				} else {
					setSearchPartido(e.target.value);
					//setArrayBusqueda({...arrayBusqueda,  "partidoB":e.target.value} )
					setFiltro({...filtro,  "partido":e.target.value} )
				}

			}
		} else {
			setSearchPartido(/./);
			//setArrayBusqueda({...arrayBusqueda,  "partidoB":0} )
			setFiltro({...filtro,  "partido":0} )
		}
	}
	//---Partido---

	//***Programa*** //ver diferencia si usa <select> o <SelectInput>
	const handleOnChangePrograma = (e) => {
		if(e.value){
			if(e.value !== null){
				//setSearchPrograma(e.value);
				//setArrayBusqueda({...arrayBusqueda,  "programaB":e.value} )
				setFiltro({...filtro,  "programa":e.value} )
			}
		} else if( e.value === ""){
			//setSearchPrograma(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			//setArrayBusqueda({...arrayBusqueda,  "programaB":e.value} )
			setFiltro({...filtro,  "programa":e.value} )

		} else if (e.target.value){
			if(e.target.value !== null){

				if(e.target.value === 0){
					//setSearchPrograma(e.target.value);
					//setArrayBusqueda({...arrayBusqueda,  "programaB":""} )
					setFiltro({...filtro,  "programa":""} )
				} else {
					//setSearchPrograma(e.target.value);
					//setArrayBusqueda({...arrayBusqueda,  "programaB":e.target.value} )
					setFiltro({...filtro,  "programa":e.target.value} )
				}
			}
		} else {
			//setSearchPrograma(/./);
			setSearchEstado(/./); //** CORRECCION 0_o 25jun24
			//setArrayBusqueda({...arrayBusqueda,  "programaB":""} )
			setFiltro({...filtro,  "programa":""} )
		}
	} //---cierra handleOnChangePrograma -----

	//***Tipo***
	const handleOnChangeTipo = (e) => {

		if(e.value){
			if(e.value !== null){
				setSearchTipo(e.value);
				//setArrayBusqueda({...arrayBusqueda,  "tipoB":e.value} )
				setFiltro({...filtro,  "tipo":e.value} )
			}
		} else if( e.value === ""){
			setSearchTipo(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			//setArrayBusqueda({...arrayBusqueda,  "tipoB":e.value} )
			setFiltro({...filtro,  "tipo":e.value} )

		} else if (e.target.value){
			if(e.target.value !== null){

				if(e.target.value === 0){
					setSearchTipo(e.target.value);
					//setArrayBusqueda({...arrayBusqueda,  "tipoB":""} )
					setFiltro({...filtro,  "tipo":""} )
				} else {
					setSearchTipo(e.target.value);
					//setArrayBusqueda({...arrayBusqueda,  "tipoB":e.target.value} )
					setFiltro({...filtro,  "tipo":e.target.value} );
				}

			}
		} else {
			setSearchTipo(/./);
			//setArrayBusqueda({...arrayBusqueda,  "tipoB":""} )
			setFiltro({...filtro,  "tipo":""} )
		}
	}

	//***Regione
	const handleOnChangeRegion = (e) => {

		if(e.value){
			if(e.value !== null){
				setSearchRegion(e.value);
				setFiltro({...filtro,  "region":e.value} )
			}
		} else if( e.value === ""){
			setSearchRegion(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			setFiltro({...filtro,  "region":e.value} )

		} else if (e.target.value){
			if(e.target.value !== null){

				if(e.target.value === 0){
					setSearchRegion(e.target.value);
					setFiltro({...filtro,  "region":""} )
				} else {
					setSearchRegion(e.target.value);
					setFiltro({...filtro,  "region":e.target.value} );
				}

			}
		} else {
			setSearchRegion(/./);
			setFiltro({...filtro,  "region":""} )
		}
	}
	//----

	//****Responsable
	const handleOnChange_Responsable = (e) => {
		
		if(e.value){ //** NOTA: entrá acá en algún momento????

			if(e.value !== null){
				//setSearchResponsable(e.value); //** QUITAR?? 0_o 26jun24
				setFiltro({...filtro,  "datos_05_responsable": e.value} )
			}
		} else if( e.value === ""){
			//setSearchResponsable(/./); //** QUITAR 0_o 26jun24
			setFiltro({...filtro,  "datos_05_responsable": e.value} )

		} else if (e.target.value){
			if(e.target.value !== null){

				if(e.target.value === 0){
					//setSearchResponsable(e.target.value);
					setFiltro({...filtro,  "datos_05_responsable": ""} )
				} else {
					//setSearchResponsable(e.target.value);
					setFiltro({...filtro,  "datos_05_responsable": e.target.value} )
				}
			}
		} else {
			//setSearchResponsable(/./);
			setFiltro({...filtro,  "datos_05_responsable":""} )
		}
	}	
	//---- cierra R_esponsable	

	const getHeader = (columnas)=>{

			return columnas.map((columna, index) => {

				if (columna === "Partido") {
					return <th key={index} >
						{columna}
					</th>
				} else if (columna === "Expediente"){
					//return <th key={index} > {columna}<input id="search" type="text" name="search" onChange={handleSearch} value={search || ''} /> </th>
					return <th key={index} > {columna} </th>
				} else if (columna === "Estado") {
					return <th key={index} >
						{columna}
					</th>
				} else if (columna === "Alias") {
					//return <th key={index} > {columna}<input id="searchA" type="text" name="alias" onChange={handleSearchAlias} value={searchAlias || ''} /> </th>
					return <th key={index} style={{ width:"100px"}}> {columna} </th>
				} else if (columna === "Cantidad lotes"){
					return <th key={index} > {columna} </th>
				} else if (columna === "Programa") {
					return <th key={index} >
						{columna}
					</th>
				} else if (columna === "Tipo") {
					return <th key={index} >
						{columna}
					</th>
				} else {
					return <th key={index} >{columna}</th>
				}
			})		
	}

	/*const getRowsData = (datosS)=> {
		//console.log("EJECUTAR AL INICIO -- REPORTE 3");
		if(datosS !== null){

			return datosS.map((registro, index )=> {
				//var partido = registro.partido_nombre;
				var expediente = registro.expediente;
				var estado = registro.estado;
				var nombre_proyecto = registro.nombre_proyecto;//nombre_proyecto
				var cantidad_lotes = registro.cantidad_lotes;
				var programa = registro.programa;
				var tipo = registro.tipo;
				//var titular = registro.titular_tierra;
				//var lotes_captados_municipio = registro.lotes_captados_municipio;
				var nomenclatura_catastral = registro.datos_18_sintesis_nomenclatura;

				return <tr id={index}> 
					<td>{registro.partido_nombre}</td>
					<td>{expediente}</td>
					<td>{estado}</td>
					<td>{nombre_proyecto}</td>
					<td>{cantidad_lotes}</td>
					<td>{programa}</td>
					<td>{tipo}</td>
					<td>{nomenclatura_catastral}</td>
				</tr>;
			})

		}
	}*/

	const [categoriaSelect, setCategoriaSelect] = useState('AA');

	const onChangeAA = (e) =>{
        console.log("select");
		const {name, value, type} = e.target;

		if(value === 'AA'){
			setCategoriaSelect('AA')
		} else {
			setCategoriaSelect('BB')
		}
    }

	const optionsCategoria = [
        {value: "AA", label: "Programa"},
        {value: "BB", label: "Estado"}
    ]

	//*** NUEVA (28-jun-24) para cargar y descargar la tabla madre ***
	const loadMadre = () => {
		getDatosMadre(url_Madre)	//change url X url_Madre
	}

	useEffect(() => {
		if(datosMadre !== null){
			document.getElementById("test-table-xls-button").click()
		}
	}, [datosMadre])
	//------cierra

	//**NUEVA (28-jun-24) ya están cargados los datos, solo descargar la tabla campos seleccionados

	const loadSeleccionados = () => {
		if(datosS !== null){
			document.getElementById("uno-table-xls-button").click()
		}
	}
	// -----cierra

	//** NUEVA (28-jun-24) para cargar y descargar la tabla reporte analitico ***
	const loadAnalitico = () => {
		getdatos_Inf2_analitico(urlRepo_Analitico);				
	}

	useEffect(() => {		
		if(datos_Inf2_Analitico !== null ){
			document.getElementById("analitico-table-xls-button").click()
		}
    }, [datos_Inf2_Analitico]);
	// ----- cierra

	//NUEVA (28-jun-24) para cargar y descargar la tabla estado actuaciones ***
	const loadActuaciones = () => {
		getdatos_Inf2_Actuaciones(urlRepo2_Actuaciones);
	}

	useEffect(() => {
		if(datos_Inf2_Actuaciones !==null ){
			document.getElementById("actuaciones-table-xls-button").click()			
		}  
	}, [datos_Inf2_Actuaciones])
	// ---- cierra

	const handleFetchData = async (action) => {

		setAction(action);
		getdatos_Inf2_GEO(urlGet_Geo);
		
	}


	if (datosS === null) {
		
		return(
			<Fragment>
				<p>INICIO hacer consulta</p>
				<div id="tabla_TODO" style={{ padding:"2px", width:"100%" }} className="">{/*border:"2px solid blue"*/}
					<div className="" style={{ width:"100%", overflow:"scroll"}} >
						<TablaInf2_Seleccionados datosS={datosS} columnas={columnas}/>
					</div>
				</div>
			</Fragment>
		)
	} else {
		//console.log("YA NO ES NULL");
		return (
			<Fragment>

				<div id="reporte2_A1" className="container_row">

					<div className="container_inicio">
						<div style={{ alignItems: "right", height: "40px", width: "95%" }} > </div>
						<div className="input-container">
							<SelectInput
								name="estado"
								id="id_estado"
								options={optionsEstado_Todos}
								onChange={e => handleOnChangeEstado(e)}
								//value={optionsEstado.value}
								defaultValue="AFECTADO CON RESOLUCIÓN"
							/>
							<label alt="Estado" for="id_estado">Estado</label>
						</div>
					</div>

					<div className="" style={{ width: "1%" }} />

					<div className="container_inicio">
						<div style={{ alignItems: "right", width: "95%" }} >
							<p className="subtitulos">
								{estado === 'TODOS' || estado === 'ANÁLISIS PRELIMINAR' || ['OBSERVADO', 'INACTIVO', 'RECHAZADO'].includes(estado) 
									? 'Rango por fecha de carga'
									: estado === 'EN PROCESO' 
									? 'Rango por fecha de caratulación'
									: ['AFECTADO CON RESOLUCIÓN', 'RECTIFICADO', 'LOTES GENERADOS'].includes(estado)
									? 'Rango por fecha emisión de resolución'
									: 'Rango por fecha de carga'}
							</p>
						</div>
						<div className="input-container">
							<DatePicker
								name="intervalo_fecha"
								selected={_fechaInicio}
								className="form-control"
								id="fecha_desde"
								onChange={(date) => setStartDate(date)}
								startDate={startDate}
								locale="es-AR"
								dateFormat="MM/yyyy"
								isClearable={false}
								required
							/>
							<label alt="Fecha desde" for="fecha_desde">Fecha desde</label>
						</div>
					</div>

					<div className="" style={{ width: "1%" }} />

					<div className="container_inicio">
						<div style={{ alignItems: "right", width: "95%" }} >
							<p className="subtitulos" style={{color: 'white'}}>Hasta</p>
						</div>
						<div className="input-container">
							<DatePicker
								name="intervalo_fecha"
								selected={ultimoDia}
								className="form-control"
								id="fecha_hasta"
								onChange={(date) => setEndDate(date)}
								endDate={ultimoDia}
								locale="es-AR"
								dateFormat="MM/yyyy"
								isClearable={false}
								required
							/>
							<label alt="Fecha hasta" for="fecha_hasta">Fecha hasta</label>
						</div>						
					</div>

					<div className="" style={{ width: "1%" }} />
					<div className="container_inicio">
						<div style={{ alignItems: "right", height: "40px", width: "95%" }} ></div> {/* border:"2px solid blue" */}
						<div className='input-container'>
							<SelectInput
								name="datos_05_responsable"
								id="id_05_responsable"
								options={optionsResponsable_Todos}
								onChange={e => handleOnChange_Responsable(e)}
								defaultValue=""
							/>{/* NUEVO select para responsable */}
							<label alt="Responsable" for="id_05_responsable">Responsable</label>
						</div>						
					</div>

				</div>

				<div className="container_left">

					<div className="input-container" style={{width: "25%"}}>
						<SelectInput
							name="partido"
							id="id_partido"
							options={ optionsRP2_Todos }
							onChange={e=>handleOnChangePartido(e)}
						/>
						<label alt="Partido" for="id_partido">Partido</label>
					</div>
					<div className="" style={{width: "1%"}} />
					<div className="input-container" style={{width: "25%"}}>
						<SelectInput
							name="programa"
							id="id_programa"
							options={optionsPrograma_Todos}
							onChange={e => handleOnChangePrograma(e)}
						/>
						<label alt="Programa" for="id_programa">Programa</label>
					</div>
					<div className="" style={{width: "1%"}} />
					<div className="input-container" style={{width: "25%"}}>
						<SelectInput
							name="tipo"
							id="id_tipo"
							options={optionsTipo_Todos}
							onChange={e => handleOnChangeTipo(e)}
						/>
						<label alt="Tipo" for="id_tipo">Tipo</label>
					</div>
					<div className="" style={{width: "1%"}} />
					<div className="input-container" style={{width: "25%"}}>
						<SelectInput
							name="region"
							id="id_region"
							options={optionsRegiones_todos}
							onChange={e => handleOnChangeRegion(e)}
						/>
						<label alt="Regiones" for="id_region">Categorías de partidos según tamaño</label>
					</div>

				</div>

				<div id="id_tablas" className="container_row">
					<div id="informes_col2" className="container_resumen_rp2">{/*columna1*/}
						<TablaInf2_Detallado datos_Inf2_finalizadosTotal={datos_Inf2_finalizadosTotal}/>						
					</div>

					
					<div className="container_resumen_rp2">
						<div style={{color: 'white'}}>
							<h2>M</h2>
							<Button form='my-form' type="button" className="btn btn-info btn-lg text_button buttonVerMapa" disabled={isLoading} onClick={() => handleFetchData('view')}>
								{(isLoading === true && action === 'view') ? 'Cargando...' : 'Ver Mapa'}
							</Button>
						</div>
					</div>					
				</div>

				<div id="reporte2_3button" className="container_row_hide">
					<div className="container_inicio">
						<ReactHTMLTableToExcel
							id="test-table-xls-button" className="btn btn-info text_button" table="table-madre-to-xls"
							filename="informe_todos_los_campos" sheet="tablexls" buttonText="Descargar XLS"
						/>
					</div>
					<div className="container_inicio">
							<ReactHTMLTableToExcel
								id="uno-table-xls-button" className="btn btn-info text_button" table="table-seleccionados-to-xls"
								filename="informe_campos_seleccionados" sheet="tablexls" buttonText="Descargar XLS"
							/>
					</div>
					<div className="container_inicio">
						<ReactHTMLTableToExcel
							id="analitico-table-xls-button" className="btn btn-info text_button" table="table-analitico-to-xls"
							filename="reporte_analítico" sheet="tablexls" buttonText="Descargar XLS"
						/>
					</div>
					<div className="container_inicio">
						<ReactHTMLTableToExcel
							id="actuaciones-table-xls-button" className="btn btn-info text_button" table="table-actuaciones-to-xls"
							filename="estado_actuaciones" sheet="tablexls" buttonText="Descargar XLS"
						/>
					</div>					
				</div>{/* QUEDA hide*/}

				{/* NUEVO ----> Para los Buttons de Descarga (C)*/}
				<div id="reporte2_3nuevoButton" className="container_row">
					<div className="container_inicio">
						<div><h6 className="mt-4 text-left subtitulos">Informe (todos los campos)</h6></div>
						<div>
							<Button form='my-form' className="btn btn-info text_button" type="button" onClick={loadMadre} disabled={isLoading}><FaFileDownload /></Button>
						</div>
					</div>

					<div className="container_inicio">
						<div><h6 className="mt-4 text-left subtitulos">Informe (campos seleccionados)</h6></div>
						<div>
							<Button form='my-form' className="btn btn-info text_button" type="button" onClick={loadSeleccionados} disabled={isLoading}><FaFileDownload /></Button>
						</div>
					</div>

					<div className="container_inicio">
						<div><h6 className="mt-4 text-left subtitulos">Reporte analítico</h6></div>
						<div>
							<Button form='my-form' className="btn btn-info text_button" type="button" onClick={loadAnalitico} disabled={isLoading}><FaFileDownload /></Button>
						</div>
					</div>

					<div className="container_inicio">
						<div><h6 className="mt-4 text-left subtitulos">Estado actuaciones</h6></div>
						<div>
							<Button form='my-form' className="btn btn-info text_button" type="button" onClick={loadActuaciones} disabled={isLoading}><FaFileDownload /></Button>
						</div>
					</div>

					<div className="container_inicio">
						<div><h6 className="mt-4 text-left subtitulos">{(isLoading === true && action === 'download') ? 'Cargando...' : 'Descargar GeoJSON'}</h6></div>
						<div>
							<button type="button" className="btn btn-info text_button" onClick={() => handleFetchData('download')} disabled={isLoading}><FaFileDownload /></button>
						</div>
					</div>
				</div>
				<div className="container_row"></div> {/* QUEDA vacio para mostrar un espacio */}			

				<div id="tabla_TODO" style={{ padding:"2px", width:"100%" }} className=""> {/*, border:"2px solid blue" */}
					<div className="" style={{ width:"100%", overflow:"scroll"}} > {/* border:"2px solid red",*/}						
						<TablaInf2_Seleccionados datosS={datosS} columnas={columnas}/>
					</div>
				</div>

				<div className="container_principal"> 
					<div>

						<div>
							<TablaInf2_Madre datosMadre={datosMadre} columnas={columnasMadre}/>
						</div>

						<div>
							<TablaInf2_Analitico datos_Inf2_Analitico={datos_Inf2_Analitico} columnas={columnasAnalitico}/>
						</div>

						<div>
							<TablaInf2_Actuaciones datos_Inf2_Actuaciones={datos_Inf2_Actuaciones} columnas={columnasActuaciones}/>
						</div>

					</div>
				</div>
				<Modal
					id="id_modal_map"
					show={showDraw}
					//onHide={handleClose}
					backdrop="static"
					keyboard={false}
					className="id_modal_map"
					//EX 21-09-2026: se quito style={{top: "200"}}. Mismo caso que datosExp.js: es herencia vieja y en un
					//modal fullscreen (que ya ocupa el 100% del alto) empujaba todo 200px hacia abajo, dejando el dialogo
					//mas alto que la ventana. Los otros 7 'top: 200' del repo NO son este caso (5 son modales id_modal_1 (son modales id_modal_1 sin
					//fullscreen, y los 2 de navigation.jsx fijan height): ahi el top si cumple una funcion y se dejan.
					size="fullscreen"
				>
					<Modal.Header style={{background: "rgb(0,174,195)", color:"white"}} >
						<Modal.Title>
							Generación de suelo urbano {/*id_exp_pruebaE*/}							
						</Modal.Title>
						<SelectInput  className="leaflet-control" style={{zIndex : 2001}} onChange={e => onChangeAA(e)} options={optionsCategoria}/>
					</Modal.Header>
					<Modal.Body>
						
						<Map_View_Expedientes categoriaSelect={categoriaSelect} partido={partido} circ='00' secc='00' datosS={datosGEO}/>
					</Modal.Body>
					<Modal.Footer>
						<Button className="btn btn-success btn-block button_verde" onClick={guardarEditRegistro} disabled="">Salir</Button>						
					</Modal.Footer>
				</Modal>				

			</Fragment>
		);
	}
}

export default SelectInf_Detallado;

//05-08-2022: QUITAR
//`buscar: Partido:{partido || '____'}--Estado:{estado  || '____'} -- priorit:{prioritario  || '____'}-- Programa:{programa || '____'}--  Tipo:{tipo  || '____'}-- `
